import TemplatesComponent from "../../modules/templates/templates";

export default function Templates() {
    return <TemplatesComponent role="organization" />;
}